module.exports = __webpack_public_path__ + "img/icon-minus.3dc8093d.svg";